/**
 * Helper function to format relative time using Intl.RelativeTimeFormat
 */
export const formatRelativeTime = (dateString: string): string => {
  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return "Invalid date";
  }

  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

  if (diffInMinutes < 1) return "Just now";
  if (diffInMinutes < 60) return rtf.format(-diffInMinutes, "minute");
  if (diffInHours < 24) return rtf.format(-diffInHours, "hour");
  if (diffInDays < 7) return rtf.format(-diffInDays, "day");
  return date.toLocaleDateString();
};
